// extracted by mini-css-extract-plugin
export default {"recommendedText":"v_VioR","currentProductText":"rLA2Jw","saleText":"o8tg5E"};